import ReactDOM from "react-dom";

import { useEffect, useState } from "react";
import classNames from "classnames";

interface Props extends React.PropsWithChildren {
  show?: boolean;
  onClose: () => void;
  className: string;
}

const Dialog: React.FC<Props> = (props) => {
  const { show, children, onClose, className } = props;
  const [visibility, setVisibility] = useState(false);

  useEffect(() => {
    if (show) {
      document.body.classList.add("dialog-open");
      setVisibility(true);
    } else {
      document.body.classList.remove("dialog-open");
      setTimeout(() => {
        setVisibility(false);
      }, 300);
    }
  }, [show]);

  if (visibility)
    return ReactDOM.createPortal(
      <div
        className={classNames(
          "fixed top-0  left-0 z-50 flex transition-opacity animate-fade-in items-center duration-300 justify-center w-screen h-screen bg-pkc-silver-50",
          show ? "opacity-100" : "opacity-0"
        )}
      >
        <div className="absolute inset-0" onClick={onClose}></div>
        <div
          className={classNames(
            " duration-300 animate-scale-up bg-white shadow-xl w-full mx-4 max-w-xl",
            className,
            show ? "scale-100" : "scale-90"
          )}
        >
          {children}
        </div>
      </div>,
      document.body
    );
  else return null;
};

export default Dialog;
